import {useCallback, useEffect, useState} from 'react';
import axios from 'axios';

/**
 * useBrands
 * Fetches all brands from the backend and provides loading/error state and a refetch function.
 *
 * @param {Object} options
 * @param {boolean} options.enabled - whether to fetch immediately (default: true)
 * @returns {{brands: Array, loading: boolean, error: any, refetch: function}}
 */
export default function useBrands(options = {enabled: true}) {
    const {enabled = true} = options;
    const [brands, setBrands] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchBrands = useCallback(async () => {
        if (!enabled) return;
        setLoading(true);
        setError(null);
        try {
            const res = await axios.get(process.env.REACT_APP_BASE_URL + '/getBrands');
            if (res && res.status === 200) {
            console.log(res,'resss')
                setBrands(Array.isArray(res.data) ? res.data : []);
            } else {
                setError(new Error('Unexpected response status: ' + (res && res.status)));
            }
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    }, [enabled]);

    useEffect(() => {
        if (enabled) fetchBrands();
    }, [fetchBrands, enabled]);

    return {
        brands,
        loading,
        error,
        refetch: fetchBrands,
    };
}

